'use client';

import type { ReactNode } from 'react';

import { useCurrentExperiment } from '@/lib/experimentation/useCurrentExperiment';
import { track } from '@/lib/tracker';

export function useTrackHomepageCTA(
  buttonText?: ReactNode,
  eventName = 'homepage_hero_cta_click'
) {
  const experiment = useCurrentExperiment();

  const trackCtaClick = () => {
    try {
      const eventPayload = {
        button_text: buttonText,
        is_in_experiment_page: !!experiment,
        ...(experiment && {
          exp_experiment_id: experiment.flagId,
          variant_id: experiment.variant,
        }),
      };

      track(eventName, eventPayload);
    } catch {}
  };

  return trackCtaClick;
}
